import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
